import type { APIOrganizationUser, ArdoqId } from '@ardoq/api-types';

export const getUserImage = (
  usersById: Record<ArdoqId, APIOrganizationUser>,
  userId: ArdoqId | undefined
): string | undefined =>
  userId ? (usersById[userId]?.linkedComponent?.image ?? undefined) : undefined;
